
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./model.css";
import "./addticket.css"

export default function UpdatTicket(props) {
    const {
        ticketRequest,
        tokenChangeHandle,
        handleFileChange,
      
        createNewToken,
        attachmentId,
        show,
        handleShow,
        handleClose

      } = props;
  
  return (
    <>
    {/* <Button variant="primary" onClick={handleShow}>
        Launch modal
    </Button> */}

    <Modal  show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
            <Modal.Title>Update Issue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {/* Your modal body content here */}
            <div class="modal-body">
              <div class="container">
                {/* <!-- project  first row --> */}
                <div class="row">
                  <div class="col-12">
                    <div class="project-model">
                      <label for="">
                      Status<span class="text-danger">*</span>
                      </label>
                      <select
                        value={ticketRequest?.status}
                        onChange={tokenChangeHandle}
                        name="status"
                        class="form-select bg-light"
                      >
                        <option value={null}>
                          <i
                            class="fa-solid fa-square-check"
                            style={{ color: "#7ea6ec" }}
                          ></i>{" "}
                          Select type
                        </option>
                        <option value="NEW">NEW</option>
                        {/* <option value="PAY_OUT">PAY_OUT</option> */}
                      </select>
                    
                    </div>
                  </div>
                </div>
                <hr />
                {/* <!-- status Secoond row --> */}
                <div class="row">
                 

                  <div class="col-12  mb-3">
                    <label for="">
                      User UTR <span class="text-danger">*</span>
                    </label>
                    <input
                      style={{ border: "1px solid green" }}
                      value={ticketRequest?.userUtr}
                      onChange={tokenChangeHandle}
                      type="text"
                      max={11}
                      pattern="[0-9]*"
                      maxLength={12}
                      name="userUtr"
                      id=""
                      class="form-control border inputbg border-2"
                    />
                  </div>
                  
                  <div class="col-12  mb-3">
                    <label for="">Comments <span class="text-danger">*</span> </label>
                    <input
                      value={ticketRequest?.comments}
                      type="text"
                      onChange={tokenChangeHandle}
                      name="comments"
                      id=""
                      class="form-control border inputbg border-2"
                    />
                  </div>
                  <div class="col-12  mb-3">
                    <label for="">
                      User Txn Date <span class="text-danger">*</span>
                    </label>
                    <input
                      value={ticketRequest?.userTxnDate}
                      type="date"
                      onChange={tokenChangeHandle}
                      name="userTxnDate"
                      id=""
                      class="form-control border inputbg border-2"
                    />
                  </div>
                    {/* <!-- Description --> */}
                    {/* <div class="col-12 mb-3">
                    <label for="">
                      Description <span class="text-danger">*</span>
                    </label>
                    <textarea
                      value={ticketRequest?.description}
                      onChange={tokenChangeHandle}
                      name="description"
                      id=""
                      cols="30"
                      rows="5"
                      class="form-control"
                    ></textarea>
                  </div> */}
                  {/* <!-- Attachment --> */}
                  <div class="col-12 mb-3">
                    <div>
                      <label htmlFor="attachment">Attachment</label>
                      <div className="border border-dotted text-center p-5">
                        <label
                          htmlFor="fileInput"
                          className="text-decoration-none"
                        >
                          <i className="fa fa-cloud-arrow-up"></i>Drop files to
                          attach or browse
                        </label>
                        <input
                          type="file"
                          id="fileInput"
                          accept="image/png, image/jpeg"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        {attachmentId?.name !== undefined &&
                          attachmentId?.name !== null && (
                            <p>Selected file: {attachmentId?.name}</p>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            <Button variant="primary" onClick={createNewToken}>
                Update
            </Button>
        </Modal.Footer>
    </Modal>
</>
  )
}
